// @version V0.0.1 [Saturday - 20210109_101255] : init

import { sendRequest } from "../api"
import { SET_OPTION } from "../constant-types"


export const defaultLoadOptionAction = {
    loadOption({commit, state}) {
        sendRequest(state.option_url, {}, 'get', (fetchedOption) => commit(SET_OPTION, fetchedOption))
    }
}